// What's New Page - Shows new features and bug fixes
import { createElement } from '@/utils/dom'
import { createSidebar } from '@/components/navigation'

interface ReleaseNote {
  date: string
  title: string
  items: {
    type: 'feature' | 'fix' | 'improvement'
    description: string
  }[]
}

const releaseNotes: ReleaseNote[] = [
  {
    date: '28 Janeiro 2026',
    title: 'Atualização de Janeiro',
    items: [
      {
        type: 'feature',
        description: 'Geração de relatórios para o ano anterior - agora pode gerar simulações para todos os 12 meses do ano passado, além do ano corrente'
      }
    ]
  },
  {
    date: '16 Dezembro 2025',
    title: 'Melhorias de Dezembro',
    items: [
      {
        type: 'feature',
        description: 'Dados empresariais e NIF incluídos na secção de checkout de pagamento para maior conformidade fiscal'
      },
      {
        type: 'feature',
        description: 'Novo relatório de Ajudas de Custo com cálculo automático de subsídios de viagem'
      },
      {
        type: 'feature',
        description: 'Secção de Motivos de Viagem personalizados - defina os seus próprios motivos de deslocação para relatórios mais realistas'
      },
      {
        type: 'improvement',
        description: 'Geração de viagens para qualquer mês anterior do ano corrente - já não está limitado apenas ao mês atual'
      }
    ]
  }
]

export class WhatsNewPage {
  private container: HTMLElement

  constructor() {
    this.container = createElement('div', { className: 'page-container whats-new-page' })
  }

  render(): HTMLElement {
    const sidebar = createSidebar('whats-new')

    const mainContent = createElement('main', { className: 'main-content' })
    mainContent.innerHTML = `
      <div class="page-header">
        <h1 class="page-title">
          <i class="fa-solid fa-gift"></i>
          Novidades
        </h1>
        <p class="page-subtitle">Novas funcionalidades e correções</p>
      </div>

      <div class="release-notes-container">
        ${this.renderReleaseNotes()}
      </div>
    `

    this.container.appendChild(sidebar)
    this.container.appendChild(mainContent)

    return this.container
  }

  private renderReleaseNotes(): string {
    return releaseNotes.map(release => `
      <div class="release-card">
        <div class="release-header">
          <div class="release-date">
            <i class="fa-solid fa-calendar"></i>
            ${release.date}
          </div>
          <h2 class="release-title">${release.title}</h2>
        </div>
        <ul class="release-items">
          ${release.items.map(item => `
            <li class="release-item ${item.type}">
              <span class="item-badge ${item.type}">
                ${this.getItemIcon(item.type)}
                ${this.getItemLabel(item.type)}
              </span>
              <span class="item-description">${item.description}</span>
            </li>
          `).join('')}
        </ul>
      </div>
    `).join('')
  }

  private getItemIcon(type: 'feature' | 'fix' | 'improvement'): string {
    switch (type) {
      case 'feature':
        return '<i class="fa-solid fa-star"></i>'
      case 'fix':
        return '<i class="fa-solid fa-wrench"></i>'
      case 'improvement':
        return '<i class="fa-solid fa-arrow-up"></i>'
    }
  }

  private getItemLabel(type: 'feature' | 'fix' | 'improvement'): string {
    switch (type) {
      case 'feature':
        return 'Novo'
      case 'fix':
        return 'Corrigido'
      case 'improvement':
        return 'Melhorado'
    }
  }
}

export function createWhatsNewPage(): HTMLElement {
  const page = new WhatsNewPage()
  return page.render()
}
